(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["software-version-history"] && !Shopify.designMode) return;
  try {
    (function () {
  var osNames = {
    windows: 'Windows',
    macos: 'Mac OS',
    android: 'Android',
  };

  function initVersionExpansion(root) {
    ['windows', 'macos', 'android'].forEach(function (os) {
      var versionContainer = root.querySelector('#' + os + '-versions');
      if (!versionContainer) return;

      var versionItems = Array.from(versionContainer.querySelectorAll('.version-item'));
      var expandBtn = versionContainer.querySelector('.expand-more-btn[data-os="' + os + '"]');
      if (!expandBtn) return;

      var versionsToHide = versionItems.slice(3);
      if (versionsToHide.length > 0) {
        expandBtn.style.display = 'inline-flex';
      } else {
        expandBtn.style.display = 'none';
      }

      var newExpandBtn = expandBtn.cloneNode(true);
      expandBtn.parentNode.replaceChild(newExpandBtn, expandBtn);

      newExpandBtn.addEventListener('click', function () {
        var isExpanded = this.classList.contains('expanded');
        if (isExpanded) {
          versionsToHide.forEach(function (item) {
            item.classList.add('hidden-version');
          });
          this.classList.remove('expanded');
          this.querySelector('span').textContent = 'View more versions';
        } else {
          versionsToHide.forEach(function (item) {
            item.classList.remove('hidden-version');
          });
          this.classList.add('expanded');
          this.querySelector('span').textContent = 'Collapse';
        }
      });
    });
  }

  function initRoot(root) {
    if (root.getAttribute('data-svh-bound') === 'true') return;
    root.setAttribute('data-svh-bound', 'true');

    var osButtons = root.querySelectorAll('.os-btn');
    var versionContents = root.querySelectorAll('.version-content');
    var selectedOsName = root.querySelector('#selected-os-name');

    osButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var selectedOs = this.getAttribute('data-os');

        osButtons.forEach(function (btn) {
          btn.classList.remove('active-os');
          btn.setAttribute('aria-selected', 'false');
        });

        this.classList.add('active-os');
        this.setAttribute('aria-selected', 'true');

        versionContents.forEach(function (content) {
          content.classList.add('hidden');
          var expandBtn = content.querySelector('.expand-more-btn');
          if (expandBtn) {
            expandBtn.classList.remove('expanded');
            var span = expandBtn.querySelector('span');
            if (span) span.textContent = 'View more versions';
            Array.from(content.querySelectorAll('.version-item')).slice(3).forEach(function (item) {
              item.classList.add('hidden-version');
            });
          }
        });

        var targetContent = root.querySelector('#' + selectedOs + '-versions');
        if (targetContent) targetContent.classList.remove('hidden');
        if (selectedOsName && osNames[selectedOs]) selectedOsName.textContent = osNames[selectedOs];
        setTimeout(function () {
          initVersionExpansion(root);
        }, 50);
      });
    });

    var windowsButton = root.querySelector('[data-os="windows"]');
    if (windowsButton) windowsButton.click();
    initVersionExpansion(root);

    root.querySelectorAll('.svh__list').forEach(function (list) {
      var container = list.parentElement;
      if (!container) return;
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'svh__collapse';
      toggle.innerHTML = '<span>Show details</span>';
      list.classList.add('hidden');
      toggle.addEventListener('click', function () {
        var isHidden = list.classList.toggle('hidden');
        var label = toggle.querySelector('span');
        if (label) label.textContent = isHidden ? 'Show details' : 'Hide details';
      });
      container.insertBefore(toggle, list);
    });
  }

  function boot() {
    document.querySelectorAll('.software-version-history').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
